import { Injectable, signal } from "@angular/core";
import { Router } from "@angular/router";

@Injectable({ providedIn: 'root' })

export class HighLevelCategoryBridgeService {
    at_home = signal<boolean>(false);
    page = signal<number>(1);
    type = signal<string>('');
    search_id = signal<any>('');
    last_page = signal<number>(0);
    current_page = signal<number>(0);
    price_filter_search = signal<any>([]);
    slug = signal<string>('');
    exp_data = signal<any>([]);
    selected_location = signal<any>('');
    categorySlug = signal<any>('');
    countrySlug = signal<any>('');
    state = signal<any>('');
    isBooking = signal<number>(0);

    constructor(private router: Router) { }

    setPage(value: number) {
        this.page.set(value);
    }

    setLastPage(value: number) {
        this.last_page.set(value);
    }

    setCurrentPage(value: number) {
        this.current_page.set(value);
    }

    setType(value: string) {
        this.type.set(value);
    }

    setSearchId(value: any) {
        this.search_id.set(value);
    }

    setAtHome(value: boolean) {
        this.at_home.set(value);
    }

    setPriceFilter(value: any) {
        this.price_filter_search.set(value);
    }

    setSlug(value: string) {
        // this.router.navigate(['/experience/' + value])
        this.slug.set(value);
    }

    setCategorySlug(value: any) {
        this.categorySlug.set(value);
    }
    setCountrySlug(value: any) {
        this.countrySlug.set(value);
    }

    setState(value: any) {
        this.state.set(value);
    }

    setExpData(value: any) {
        this.exp_data.set(value);
    }

    setSelectedLocation(value: any) {
        this.selected_location.set(value);
    }

    setCategoryRedirect(value) {
        this.router.navigate(['/experience/' + value]);
    }

    setIsBooking(value: any) {
        this.isBooking.set(value);
    }
}